import "./Footer.scss"
const Footer = () => {
  return (
    <div className="footer">
      <p>© Copyright 2023 | Onur Kapucu</p>
    </div>
  )
}

export default Footer
